import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { APP_ID, ApplicationConfig, FactoryProvider, Injector } from '@angular/core';

import { CURRENCY_PROVIDER, GRAPHQL_PROVIDERS, USER_CONTEXT_LOADER_PROVIDER } from '@hdms/shared/data-access';
import {
  ENVIRONMENT,
  EnvironmentService,
  HTTP_INTERCEPTOR_PROVIDERS,
  LOGGER_PROVIDER,
  LegacyLogoutService,
  LogoutService,
  PRELOADER_CONTROL_PROVIDERS,
  ROUTER_BREADCRUMB_SERVICE_PROVIDER,
  StandaloneLogoutService
} from '@hdms/shared/util-core';

import { environment } from '../environments/environment';

import { HDMS_APP_ID } from './constants';
import { APP_TRANSLATION_PROVIDERS } from './i18n/app-translation.providers';
import { APP_ROUTING_PROVIDERS } from './routing/app-routing.providers';
import { URL_SERIALIZER_PROVIDER } from './routing/custom-url.serializer';
import { PAGE_FRAME_PROVIDER } from './services/page-frame-loader.service';

// TODO: to be removed once Angular is decoupled from Hybris.
const LOGOUT_PROVIDER: FactoryProvider = {
  provide: LogoutService,
  useFactory: ({ isStandalone, hostContext }: EnvironmentService, injector: Injector) =>
    injector.get<LogoutService>(isStandalone || hostContext ? StandaloneLogoutService : LegacyLogoutService),
  deps: [EnvironmentService, Injector]
};

/**
 * Providers used in server and browser environment
 */
export const APP_COMMON_CONFIG: ApplicationConfig = {
  providers: [
    provideHttpClient(withJsonpSupport(), withInterceptorsFromDi()),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: APP_ID, useValue: HDMS_APP_ID },
    { provide: APP_BASE_HREF, useValue: '/' },
    PRELOADER_CONTROL_PROVIDERS,
    GRAPHQL_PROVIDERS,
    HTTP_INTERCEPTOR_PROVIDERS,
    APP_ROUTING_PROVIDERS,
    APP_TRANSLATION_PROVIDERS,
    USER_CONTEXT_LOADER_PROVIDER,
    ROUTER_BREADCRUMB_SERVICE_PROVIDER,
    CURRENCY_PROVIDER,
    URL_SERIALIZER_PROVIDER,
    PAGE_FRAME_PROVIDER,
    LOGGER_PROVIDER,
    LOGOUT_PROVIDER
  ]
};
